// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePrescriberPhonesModel {
    static getAttributeTypeMap() {
        return SimpleIntakePrescriberPhonesModel.attributeTypeMap;
    }
}
SimpleIntakePrescriberPhonesModel.discriminator = undefined;
SimpleIntakePrescriberPhonesModel.additionalProperties = false;
SimpleIntakePrescriberPhonesModel.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "SimpleIntakePhoneModel"
    },
    {
        "name": "main",
        "baseName": "main",
        "type": "SimpleIntakePhoneModel"
    },
];
//# sourceMappingURL=simpleIntakePrescriberPhonesModel.js.map